import { useState } from "react";
import Form from "react-bootstrap/Form";

export default function AttribueFilter(props) {

  const [attributesCollapsed, setAttributesCollapsed] = useState(false);
  // collapsible checkboxes list for available attributes for the products (eg color) 

  let prevAttrKey = "";

  const filterHeader = (
    <>
    <Form.Label
      className="fw-bold mb-0"
      style={{ display: "flex", justifyContent: "space-between"}}
    >
      Attributes
      <div >

      {props?.selectedAttributes && props.selectedAttributes.length > 0 && <i
        className="bi bi-arrow-counterclockwise me-3 pointer"
        style={{cursor: "pointer" }}
        onClick={() => {props.handleChangeAttributes(-1, -1)}}
      ></i>}
      {attributesCollapsed ? <i onClick={() => setAttributesCollapsed(false)} className="bi bi-plus pointer"></i> : <i onClick={() => setAttributesCollapsed(true)} className="bi bi-dash pointer"></i>}
    
      </div>
    </Form.Label>
    </ >
  );

  return (
    <>
    {filterHeader}
      <div className={`mb-2 ms-2 ${attributesCollapsed && "hide-element"}`}>
        {props?.availableAttributesSet.map((attr, idx) => {
          const keyVal = attr.name.split(":"); // = [key, value]
          const showKey = keyVal[0] !== prevAttrKey;
          prevAttrKey = keyVal[0];
          return (
            <div key={attr._id}>
              {showKey && (
                <Form.Label className="mt-2" style={{display: "flex", justifyContent: "space-between", fontWeight: "700", fontStyle: "italic"}}>
                  {keyVal[0]}
         
                </Form.Label>
              )}
              <Form.Check type="checkbox" id={`idx-${idx}`}>
                <Form.Check.Input
                  type="checkbox"
                  isValid
                  checked={props?.selectedAttributes.includes(attr._id) || false}
                  onChange={(event) => {
                    const isChecked = event.target.checked;

                    props.handleChangeAttributes(attr._id, isChecked);
                  }}
                />
                <Form.Check.Label style={{ cursor: "pointer", color: "black" }}>
                  {keyVal[1]}
                </Form.Check.Label>
              </Form.Check>
            </div>
          );
        })}
      </div>
    </>
  );
}

